module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length == 0),
      expression: "list.length == 0"
    }],
    staticClass: "nothing-wrap"
  }, [_c('img', {
    staticClass: "nothing",
    attrs: {
      "src": require("assets/image/list-nothing.png")
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7bf25bfc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/noData.vue
// module id = 768
// module chunks = 1